module.exports = __webpack_public_path__ + "img/playing_1.30acc69e.svg";